import React from 'react';
import { IMatrixMessage } from '../../../client/message/types';

interface InviteMessageProps {
  message: IMatrixMessage;
  className?: string;
}

export const InviteMessage = ({ message, className = '' }: InviteMessageProps) => {
  const inviter = message.sender;
  const invitee = message.content.displayname || '';
  const membership = message.content.membership;

  if (membership === 'invite') {
    return (
      <div
        className={`invite-message ${className}`}
        style={{
          color: '#fff',
          background: '#1976d2',
          borderRadius: 6,
          padding: '8px 12px',
          fontWeight: 500,
          display: 'inline-block',
          maxWidth: '100%',
        }}
      >
        {inviter
          ? `${inviter} 邀请了 ${invitee || '你'} 加入群聊`
          : `你被邀请加入群聊`}
      </div>
    );
  }
  if (membership === 'join') {
    return (
      <div
        className={`invite-message ${className}`}
        style={{
          color: '#fff',
          background: '#388e3c',
          borderRadius: 6,
          padding: '8px 12px',
          fontWeight: 500,
          display: 'inline-block',
          maxWidth: '100%',
        }}
      >
        {invitee
          ? `${invitee} 已接受邀请加入群聊`
          : `有成员已接受邀请加入群聊`}
      </div>
    );
  }
  // 兜底
  return null;
}; 